import {
    useOpenConversationWithEnterKey,
    useSelectConversationWithSpaceBar,
    useDeselectConversationWithEscape,
} from 'src/pages/landlord/conversations/components/key-listener/hooks';
import type { IConversation } from 'src/api/landlord-messages-api';
import type { IConversationMatchWithChannel } from 'src/pages/landlord/conversations/context/types';

type Props = {
    focusedConversation?: IConversation;
    selectedConversations: Array<IConversation | IConversationMatchWithChannel>;
    setSelectedConversations: React.Dispatch<React.SetStateAction<Array<IConversation | IConversationMatchWithChannel>>>;
    openConversation: (conversation: IConversation | IConversationMatchWithChannel, backPath: string) => void;
};

export default function ConversationsKeyListener({
    focusedConversation,
    selectedConversations,
    setSelectedConversations,
    openConversation,
}: Props) {
    useSelectConversationWithSpaceBar({
        focusedConversation,
        setSelectedConversations
    });
    useDeselectConversationWithEscape({
        focusedConversation,
        selectedConversations,
        setSelectedConversations
    });
    useOpenConversationWithEnterKey({
        focusedConversation,
        openConversation
    });

    return null;
}
